import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';


const Tablature = () => {
  const [tablatures, setTablatures] = useState([]);


  
  const getYouTubeVideoId = (url) => {
    const match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)))?([^"&?\/\s]{11})/);
    return match?.[1] || null;
  };
  
 

  useEffect(() => {
    // Fonction pour extraire l'identifiant de la vidéo YouTube à partir du lien
    const getYouTubeVideoId = (url) => {
      const match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)))?([^"&?\/\s]{11})/);
      return match?.[1] || null;
    };

    axios.get(`${process.env.REACT_APP_API}/tabs`)
      .then((response) => {
        setTablatures(response.data);
      })
      .catch((error) => {
        console.log('Erreur lors de la récupération des tablatures:');
      });
  }, []); 


  return (
    <main>
    <section className="tabs">
      <h1 className="heading">Tablatures</h1>
      <section className="box-container">
        {tablatures.map((tab) => (
          <article key={tab._id} className="box">
            <section className="admin">
              <article className="info">
                <h3>{tab.login}</h3>
                <p>{new Date(tab.createdAt).toLocaleDateString()}</p>
              </article>
            </section>
            <section className="thumb">
              <iframe
                width="330"
                height="315"
                src={`https://www.youtube.com/embed/${getYouTubeVideoId(tab.youtubeLink)}`}
                allowFullScreen
                title={tab.title}
              ></iframe>
            </section>
            <h3 className="title">{tab.artist} - {tab.title}</h3>
            <NavLink to={`/playlist/${tab._id}`} className="purple-btn">
              En savoir plus...
            </NavLink>
          </article>
        ))}
      </section>
    </section>
  </main>
);
};

export default Tablature;
